<p class="hive-paragraph-small hive-paragraph-regular">
    Renew <span class="eosc-renew-call-to-action__highlight--success">Support Contract</span>
</p>
